import { useEffect, useRef } from 'react';

export default function MouthpieceConcerns() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-up-item').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const concerns = [
    {
      image: 'https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-170x182_webp_c60dbf63-0c20-4b98-ae32-e8f5daaf10b5.webp',
      title: '続けられるかどうか',
      tags: ['自己管理', '生活リズム', '性格との相性'],
    },
    {
      image: 'https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-328x180_webp_361c8245-a4cb-4589-8dad-17cb266d53a4.webp',
      title: '見た目・話しやすさ',
      tags: ['装着中の印象', '話しにくさ', '処置に伴う見た目の変化'],
    },
    {
      image: 'https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-184x213_webp_92aab2e6-3e40-44ad-85aa-8fd48eb95111.webp',
      title: '結果とお金の見通し',
      tags: ['計画が変わる理由', '価格が変わる仕組み', '追加が出やすいケース/出にくいケース'],
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-16 fade-up font-serif"
        >
          マウスピース矯正を考えるとき、<br />
          多くの方が気にしていることがあります。
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {concerns.map((concern, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 hover:shadow-md transition-shadow fade-up-item"
            >
              <div className="flex justify-center mb-6">
                <img
                  alt={concern.title}
                  className="h-24 w-auto object-contain"
                  src={concern.image}
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-6 font-serif">{concern.title}</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {concern.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="bg-gray-100 text-gray-700 px-4 py-2 rounded-full text-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center fade-up">
          <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
            これらは、<br />
            マウスピース矯正を検討する上で<br />
            とても自然な疑問です。<br />
            <br />
            そして実は、<br />
            事前に整理しておくことで、<br />
            多くは防げるものでもあります。
          </p>
        </div>
      </div>
    </section>
  );
}